// Module
var code = `<div class="sd-translation-line-skeleton">
</div>
`;
// Exports
export default code;